import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, justifyContent, alignItems, flexDirection } from '../../styles/helpers/flexbox';

const AddTopicContainer = styled.div`
    ${flexbox()}
    ${justifyContent('center')}
    ${alignItems('center')}
    ${flexDirection('column')}
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
`;

const EditTopicHeader = styled.div((props) => {
    const { palette, typography } = ThemeHelper.getTheme(props);

    return `
    color: ${palette.primary.dark};
    font-family: ${typography.family};
    position: absolute;
    top: 40px;
    font-weight: 900;
    `;
});

const RequiredFields = styled(EditTopicHeader)`
    right: 50px;
    font-weight: 100;

    &:before {
        content: '* ';
        color: red;
    }
`;

const ErrorMessage = styled.span((props) => {
    const { palette } = ThemeHelper.getTheme(props);

    return `
    ${flexbox()}
    ${alignItems('center')}
    color: ${palette.error.main};
    top: 30px;
    width: 100%;
    height: 38px;
    padding: 8px 125px;
    position: absolute;
    font-size: 11px;
    `;
});

const TopicName = styled.div((props) => {
    const { colours, palette, typography } = ThemeHelper.getTheme(props);

    return `
    ${flexbox()}
    ${alignItems('center')}
    color: ${palette.primary.dark};
    font-family: ${typography.family};
    position: absolute;
    top: 90px;
    width: 90%;

    > span {
        min-width: 115px;
    }

    > input {
        width: 100%;
        height: 38px;
        padding: 8px 22px;
        border: 1px solid ${props.hasError ? palette.error.main : colours.grey[200]};
        border-radius: 5px;
        font-family: ${typography.family};
        font-size: 15px;
        outline: none;

        &::-webkit-input-placeholder {
            color: ${colours.grey[200]};
            font-size: 15px;
        }

        &:-ms-input-placeholder {
            color: ${colours.grey[200]};
            font-size: 15px;
        }
    }

    &: before {
        content: '* ';
        color: red;
    }
    `;
});

const TopicType = styled(TopicName)`
    top: 160px;

    .topicTypeSelect {
        width: 200px;
    }
`;

const CurriculumLink = styled(TopicName)((props) => {
    const { isRequired } = props;

    return `
        top: 310px;

        &: before {
            ${isRequired ? (
        `
                content: '* ';
                color: red;
                `
    ) : (
        'content: none;'
    )}
        }
    `;
});


const ExternalKey = styled(CurriculumLink)`
    top: 370px;
`;

const Description = styled(ExternalKey)((props) => {
    const { colours, typography } = ThemeHelper.getTheme(props);
    return `
    top: 420px;

    > textarea {
        width: 100%;
        height: 120px;
        padding: 8px 22px;
        border: 1px solid ${colours.grey[200]};
        border-radius: 5px;
        font-family: ${typography.family};
        font-size: 15px;
        outline: none;
        resize: none;
    `;
});

const ContentWrapper = styled.div((props) => {
    const { palette, typography } = ThemeHelper.getTheme(props);

    return `
    ${flexbox()}
    ${justifyContent('center')}
    ${alignItems('left')}
    ${flexDirection('column')}
    color: ${palette.primary.dark};
    font-family: ${typography.family};
    border: 1px solid ${palette.primary.dark};
    position: relative;
    background-color: white;
    height: 630px;
    width: 600px;
    padding: 20px
    `;
});

const Close = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    margin: 5px;
    user-select: none;
    cursor: pointer;
`;

const ButtonsWrapper = styled.div`
    ${flexbox()}
    position: absolute;
    bottom: 20px;
    right: 30px;
    width: 90%;

    .deletePanel {
      width: 100%;
      text-align: left;
      padding-right: 5px;
      padding-top: 7px;

      .iconStyle {
            width: 24px;
            height: 25px;
            cursor: pointer;
            float: right;

             svg {
                  path { fill: #4e5c67 !important; }
             }
        }

        .confirmationPanel {
          font-weight: 500;
          ${flexbox()}
          width: 100%;

           .message {
                width: 85%;
                text-align: right;
                padding-top: 5px;
                color: #4e5c67;
                font-weight: 600;
           }

           .buttonPanel {
              width: 15%;
              text-align: center;
              ${flexbox()}
              ${justifyContent('space-evenly')}

              svg {
                  path { fill: white !important; }
              }

              .cross {
                 width: 24px;
                 height: 25px;
                 cursor: pointer;
                 background: red;
                 border-radius: 15px
              }

              .tick {
                 width: 24px;
                 height: 25px;
                 cursor: pointer;
                 background: green;
                 border-radius: 15px
              }

              .btnIconStyle {
                 width: 15px;
                 height: 15px;
                 margin: auto;
                 padding-top: 5px;
              }
           }
        }
    }
`;

const Filters = styled.div`
    width: 140px;
`;

const FilterWrapper = styled.div`
    ${flexbox()}
    ${justifyContent('right')}
    ${justifyContent('space-between')}
    position: absolute;
    top: 220px;
    width: 320px;
    margin-left: 130px;
`;

export { AddTopicContainer,
    ContentWrapper,
    Close,
    EditTopicHeader,
    RequiredFields,
    TopicName,
    ButtonsWrapper,
    Filters,
    FilterWrapper,
    TopicType,
    CurriculumLink,
    ExternalKey,
    Description,
    ErrorMessage
};



// WEBPACK FOOTER //
// ./app/components/add-topic/styled.js